export const unlayerFormFields = {
  value: [
    {
      name: 'first_name',
      type: 'text',
      label: 'First Name',
      placeholder_text: 'First Name',
      show_label: true,
      required: true,
    },
    {
      name: 'last_name',
      type: 'text',
      placeholder_text: 'Last Name',
      label: 'Last Name',
      show_label: true,
      required: true,
    },
    {
      name: 'email',
      type: 'email',
      label: 'Email',
      placeholder_text: 'Enter email address here',
      show_label: true,
      required: true,
    },
    {
      name: 'vessel-id',
      value: '[VESSEL_ID_HASH]',
      type: 'hidden',
      label: 'Hidden! Do not delete!',
      show_label: true,
      required: true,
    },
    {
      name: 'campaign-id',
      value: '[CAMPAIGN_ID_HASH]',
      type: 'hidden',
      label: 'Hidden! Do not delete!',
      show_label: true,
      required: true,
    },
    {
      name: 'step-id',
      value: '[STEP_ID_HASH]',
      type: 'hidden',
      label: 'Hidden! Do not delete!',
      show_label: true,
      required: true,
    },
    {
      name: 'target-step-id',
      value: "[STEP_ID order=2]",
      type: 'hidden',
      label: 'Hidden! Do not delete!',
      show_label: true,
      required: true,
    },
  ],
  editor: {
    data: {
      defaultFields: [
        {
          name: 'name[]',
          label: 'First Name',
          type: 'text',
          show_label: true,
        },
        {
          name: 'name[]',
          label: 'Last Name',
          type: 'text',
          show_label: true,
        },
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          show_label: true,
        },
        {
          name: 'phone_number',
          label: 'Phone Number',
          type: 'text',
          show_label: true,
        },
        {
          name: 'date_of_birth',
          label: 'Birthday',
          type: 'date',
          show_label: true,
        },
        {
          name: 'gender',
          label: 'Gender',
          type: 'text',
          show_label: true,
        },
        {
          name: 'employer',
          label: 'Employer',
          type: 'text',
          show_label: true,
        },
        {
          name: 'website',
          label: 'Website',
          type: 'text',
          show_label: true,
        },
        {
          name: 'zip',
          label: 'Zip Code',
          type: 'text',
          show_label: true,
        },
        {
          name: 'comments',
          label: 'Comments',
          type: 'textarea',
          show_label: true,
        },
      ],
    },
  },
};
